import React from 'react';
import Steps from '../ModalController/Steps';
import EditActivityForm from './EditActivityForm';
import EditActivityFormV2 from './EditActivityFormV2';
import EditGroupedActivityForm from './EditGroupedActivityForm';
import EditGroupedActivityFormV2 from './EditGroupedActivityFormV2';
import useLaunchDarkly from 'hooks/useLaunchDarkly';

const EditActivity = ({ data = {}, onClose }) => {
  const flags = useLaunchDarkly();
  const activity_type = data?.activity?.activity_type;

  return (
    <Steps>
      <Steps.Item>
        {activity_type !== 'incident_activity' ? (
          flags['activities-feed'] ? (
            <EditGroupedActivityFormV2 data={data} onClose={onClose} />
          ) : (
            <EditGroupedActivityForm data={data} onClose={onClose} />
          )
        ) : flags['activities-feed'] ? (
          <EditActivityFormV2 data={data} onClose={onClose} />
        ) : (
          <EditActivityForm data={data} onClose={onClose} />
        )}
      </Steps.Item>
    </Steps>
  );
};

export default EditActivity;
